/**
 * Moduldefinitionen
 */
export enum PermissionList {
    /*----------------------*/
    /*----- module zew -----*/
    /*----------------------*/
    MODULE_ZEW = 100,
    MODULE_ZEW_TIMERECORDS_ADD = 101,
    MODULE_ZEW_TIMERECORDS_MODIFY = 102,
    /*----- absences -----*/
    MODULE_ZEW_ABSENCES = 106,
    MODULE_ZEW_ABSENCES_ADD = 107,
    MODULE_ZEW_ABSENCE_TYPE_F = 108,
    MODULE_ZEW_ABSENCE_TYPE_K = 109,
    MODULE_ZEW_ABSENCE_TYPE_E = 110,
    MODULE_ZEW_ABSENCE_TYPE_M = 111,
    MODULE_ZEW_ABSENCE_TYPE_Z = 112,
    MODULE_ZEW_ABSENCE_TYPE_C = 113,
    MODULE_ZEW_ABSENCE_TYPE_SK = 114,
    /*----- expenses -----*/
    MODULE_ZEW_EXPENSES = 116,
    MODULE_ZEW_EXPENSES_ADD = 117,
    MODULE_ZEW_EXPENSE_TYPE_PAR = 118,
    MODULE_ZEW_EXPENSE_TYPE_VER = 119,
    MODULE_ZEW_EXPENSE_TYPE_HOT = 120,
    MODULE_ZEW_EXPENSE_TYPE_BEN = 121,
    MODULE_ZEW_EXPENSE_TYPE_TRA = 122,
    MODULE_ZEW_EXPENSE_TYPE_BM = 123,
    MODULE_ZEW_EXPENSE_TYPE_POR = 124,
    MODULE_ZEW_EXPENSE_TYPE_DIV = 125,
    /*----------------------*/
    /*---- module ToDo -----*/
    /*----------------------*/
    MODULE_TODO = 200,
    MODULE_TODO_SELF_ONLY = 201,
    MODULE_TODO_SELF_TEAM_ONLY = 202,
    MODULE_TODO_ALL = 203,
}
